import * as API from "@/services/API";
import { RecordIdentifier } from "@/data/global";

export default {
    targets() {
        return API.apiClient.get(`/newsletter/targets`);
    },
    subscribe(email: string, target: string) {
        return API.apiClient.post(`/newsletter/subscribe`, { email, target });
    },
}
